export const errors = {
  "404": "Page Not Found",
  "403": "Access Denied",
  "500": "Server Error",
  maintenance: "Maintenance Mode",
  goHome: "Go to Homepage",
};

export const errorPage = {
  title404: "404 - Page Not Found",
  subtitle404: "Unfortunately, the page you are looking for does not exist.",
  title403: "403 - Access Denied",
  subtitle403: "You do not have the required permissions for this page.",
  whatHappenedDesc403: "The requested resource cannot be accessed with your current account.",
  reason403Login: "Log in with a different account or contact support.",
  title500: "500 - Internal Server Error",
  subtitle500: "Something went wrong on our servers.",
  whatHappenedDesc500: "We couldn’t render this page due to an unexpected issue.",
  reason500Server: "An unexpected server error occurred.",
  reason500Retry: "Try again later or reach out to support.",
  titleMaintenance: "Maintenance Mode",
  subtitleMaintenance: "We’re temporarily offline for maintenance.",
  whatHappenedDescMaintenance: "The platform is currently unavailable while we perform scheduled work.",
  reasonMaintenanceScheduled: "Scheduled system maintenance in progress.",
  reasonMaintenanceUpdates: "We are deploying updates and improvements.",
  whatHappenedTitle: "What happened",
  whatHappenedDesc: "The requested page could not be found",
  reasonsIntro: "This can have various reasons:",
  reasonWrongUrl: "The URL was entered incorrectly",
  reasonMoved: "The page was moved or deleted",
  reasonOutdated: "The link you followed is outdated",
  reasonPermission: "You do not have permission to access this page",
  goHome: "Go to Homepage",
  startSearch: "Start Search",
  goBack: "Go Back",
  needHelpTitle: "Need Help",
  needHelpText: "If you believe this is an error or need further assistance, you can contact our support team.",
  visitHelpCenter: "Visit Help Center",
  contactSupport: "Contact Support",
  quickLinksIntro: "Or visit one of these pages:",
  categories: "Categories",
  statistics: "Statistics",
  myAccount: "My Account",
  administration: "Administration",
  login: "Login",
};